import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/fr";

//@ts-ignore-error
const fr = (dayjs as any).Ls.fr;

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);
dayjs.extend(customParseFormat);

dayjs.locale("fr");

dayjs.updateLocale("fr", {
  relativeTime: {
    future: "dans %s",
    past: "il y a %s",
    s: "quelques secondes",
    m: "une minute",
    mm: "%d minutes",
    h: "une heure",
    hh: "%d heures",
    d: "un jour",
    dd: "%d jours",
    M: "un mois",
    MM: "%d mois",
    y: "un an",
    yy: "%d ans",
  },
});

dayjs.locale(
  {
    ...fr,
    name: "fr-short",
    relativeTime: {
      future: "dans %s",
      past: "il y a %s",
      s: "%d s",
      m: "1 min",
      mm: "%d min",
      h: "1 h",
      hh: "%d h",
      d: "1 j",
      dd: "%d j",
      M: "1 mois",
      MM: "%d mois",
      y: "1 an",
      yy: "%d ans",
    },
  },
  undefined,
  true,
);

export default dayjs;
